import { Link } from "react-router-dom";
import { QOVARIX_NAVBAR_LOGO_PATH } from "@/constants/assets";

const LEGAL = [
  { label: "Terms & Conditions", href: "/legal/terms" },
  { label: "Privacy Policy", href: "/legal/privacy" },
  { label: "Risk Disclosure", href: "/legal/risk" },
  { label: "Cookie Policy", href: "/legal/cookies" },
];

const RESOURCES = [
  { label: "Whitepaper", href: "/docs/whitepaper", internal: true },
  { label: "Overview", href: "/docs/overview", internal: true },
  { label: "Learn", href: "/docs/learn", internal: true },
];

const SOCIAL = [
  { label: "Twitter / X", href: "https://x.com/Qovarix" },
  { label: "Discord", href: "https://discord.gg/m7pPSyccnT" },
  { label: "Telegram", href: "https://t.me/qovarix" },
  { label: "GitHub", href: "https://github.com/qovarix" },
  { label: "Surge", href: "https://surge.gg" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative z-20 border-t border-white/5" style={{ background: "#020304" }}>
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <img src={QOVARIX_NAVBAR_LOGO_PATH} alt="Qovarix" width={200} height={56} className="h-10 w-auto max-w-[220px] object-contain mb-4 opacity-90" />
            <p className="font-grotesk text-xs text-slate-600 leading-relaxed">
              High-frequency, AI-powered prediction markets on Base Chain. Non-custodial by design.
            </p>
          </div>

          {/* Docs */}
          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 block mb-4">Docs</span>
            <ul className="space-y-2">
              {RESOURCES.map((r) => (
                <li key={r.label}>
                  <Link to={r.href} className="font-grotesk text-xs text-slate-500 hover:text-[#00F0FF] transition-colors">
                    {r.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Community */}
          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 block mb-4">Community</span>
            <ul className="space-y-2">
              {SOCIAL.map((s) => (
                <li key={s.label}>
                  <a href={s.href} target="_blank" rel="noopener noreferrer" className="font-grotesk text-xs text-slate-500 hover:text-[#00F0FF] transition-colors">
                    {s.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="mailto:contact@blocknexalabs.com" className="font-grotesk text-xs text-slate-500 hover:text-[#00F0FF] transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 block mb-4">Legal</span>
            <ul className="space-y-2">
              {LEGAL.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.href}
                    data-testid={`footer-legal-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-+$/, "")}`}
                    className="font-grotesk text-xs text-slate-500 hover:text-slate-300 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[9px] text-slate-600 text-center sm:text-left">
            &copy; 2026 BlockNexa Labs. All rights reserved. Qovarix is a product of BlockNexa Labs.
          </p>
          <p className="font-mono text-[9px] text-slate-700 text-center sm:text-right max-w-md">
            Closed beta access is limited and subject to approval. Trading prediction markets involves substantial risk including possible loss of all funds. This is not investment advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
